import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from './/components/Home';
import Blogs from './/components/Blogs';
import Projects from './/components/Projects';
import HttpStatusCodes from './components/HttpStatusCodes'
import GitIntro from './components/GitIntro'
import Contact from './components/Contact'
import Resume from './components/Resume'
import NotFound from './components/NotFound'
import './styles.css';
import './popup.css';
import './try.css';
import ogImage from "./imgs/og-image.jpg"
import { Helmet } from "react-helmet";

function App() {
  return (
    <>


      <BrowserRouter>
        <Helmet>
          <meta property="twitter:card" content={ogImage} />
          <meta property="twitter:image" content={ogImage} />
          <meta property="og:image" content={ogImage} />
        </Helmet>
        <Switch >
          <Route exact path="/" component={Home} />
          <Route exact path="/Home" component={Home} />
          <Route exact path="/blogs" component={Blogs} />
          <Route exact path="/projects" component={Projects} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/resume" component={Resume} />
          <Route exact path="/HttpStatusCodes" component={HttpStatusCodes} />
          <Route exact path="/GitIntro" component={GitIntro} />
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>


    </>
  );
}

export default App;
